module.exports = __webpack_public_path__ + "static/img/14000510.bf3ae801.png";